exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".referans-mizan-report-table[data-v-d55f342e],.referans-mizan-report-table>*[data-v-d55f342e]{width:100%}", ""]);

// exports
